import { css, keyframes } from "@emotion/react";

import { encodeSVGComponentToDataURI } from "@utils/helpers/svg";

export const ShinyTextStyles = () => css`
  ${ShinyAnimationStyles()}
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const ShinySVGStyles = (SVGElement) => css`
  height: 32px;
  width: 32px;

  ${ShinyAnimationStyles()}

  --mask: url(${encodeSVGComponentToDataURI(SVGElement)});

  -webkit-mask-image: var(--mask);
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  -webkit-mask-size: contain;

  mask-image: var(--mask);
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
`;

const ShinyAnimationStyles = () => css`
  --gradient-start-color: black;
  --gradient-end-color: lightgray;
  --animation-duration: 4s;

  animation: ${textAnimation} var(--animation-duration) infinite normal linear;
  background-image: linear-gradient(
    90deg,
    var(--gradient-start-color),
    var(--gradient-end-color),
    var(--gradient-start-color),
    var(--gradient-end-color),
    var(--gradient-start-color),
    var(--gradient-end-color)
  );
  background-size: 510% 100%;
`;

const textAnimation = keyframes`
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: 100% 0;
    }
`;
